"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function FilterIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M10.192,21.392a.852.852,0,0,1-.851-.85l0-7.231-4.972-8.4a1.619,1.619,0,0,1-.017-1.5,1.449,1.449,0,0,1,1.276-.793l12.748-.009a1.443,1.443,0,0,1,1.276.792,1.588,1.588,0,0,1,.014,1.45l-4.988,8.457,0,5.773a.85.85,0,0,1-.533.789L10.508,21.33A.867.867,0,0,1,10.192,21.392ZM5.987,4.317l4.931,8.327a.856.856,0,0,1,.118.433l0,6.207,1.936-.778,0-5.43a.843.843,0,0,1,.117-.433l4.919-8.334Z" })));
}
exports.default = FilterIcon;
